import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

/**
 * Search across private/public chat messages and team messages.
 *
 * @param {string} q - Search query (min 2 chars)
 * @param {number} [limit=10] - Max results per category
 * @returns {Promise<{ chat_results: Array, team_results: Array }>}
 */
export const searchMessages = (q, limit = 10) => {
  try {
    return axios.get(
      BASE_URL +
        "search/messages?q=" +
        encodeURIComponent(q) +
        "&limit=" +
        limit,
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};
